/*###########################################################################
// Lighten colour
//#########################################################################*/

export const lightenColour = (color, percent) => {
	const rgb = color.match(/\d+/g)
	if (!rgb) return color
	let [r, g, b] = rgb
	r = Math.min(255, Math.floor(r * (1 + percent)))
	g = Math.min(255, Math.floor(g * (1 + percent)))
	b = Math.min(255, Math.floor(b * (1 + percent)))
	if (color.startsWith('rgba')) {
		const a = rgb[3] !== undefined ? rgb[3] : 1
		return `rgba(${r},${g},${b},${a})`
	}
	return `rgb(${r},${g},${b})`
}

